export default "__VITE_ASSET__X3wC7gnU__"